import { ChatterStatus } from '@/api/resources/chatters/model'
export const statuses = {
  [ChatterStatus.INIT]: {
    label: 'Профиль не заполнен',
    type: 'danger',
  },
  [ChatterStatus.PROFILE_FILLED]: {
    label: 'Профиль заполнен',
    type: 'warning',
  },
  [ChatterStatus.CONDITIONS_SENT]: {
    label: 'Условия отправлены',
    type: 'warning',
  },
  [ChatterStatus.SIGNED_TO_WEBINAR]: {
    label: 'Записан на вебинар',
    type: 'info',
  },
  [ChatterStatus.WEBINAR_CODE_PROVIDED]: {
    label: 'Код вебинара предоставлен',
    type: 'info',
  },
  [ChatterStatus.CONDITIONS_CONFIRMED]: {
    label: 'Условия подтверждены',
    type: 'success',
  },
  [ChatterStatus.TEST_PASSED]: {
    label: 'Тест пройден',
    type: 'success',
  },
  [ChatterStatus.VERIFIED]: {
    label: 'Верифицирован',
    type: 'success',
  },
  [ChatterStatus.ZERO_SHIFT]: {
    label: 'Нулевая смена',
    type: 'info',
  },
  [ChatterStatus.FIFTH_SHIFT]: {
    label: 'Пятая смена',
    type: 'info',
  },
  [ChatterStatus.TEAM]: {
    label: 'Основной состав',
    type: 'success',
  },
}

// Every row of the chatters table renders `getStatus(row.status).label`, so an
// API that has learned a status this build has not used to take the whole table
// down on `undefined.label`. Falling back to the raw key keeps it readable and
// makes the next status somebody adds a display bug rather than an outage.
export const getStatus = (status: ChatterStatus) => {
  return statuses[status] ?? { label: status, type: 'info' }
}
